import { PDFDocument, rgb } from 'pdf-lib';
import fontkit from "@pdf-lib/fontkit";
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import { getSignatureCertificateVendor } from '../../../../../actions/vendor';

function CheckNumber(Number) {
    var decimal = false;
    Number = Number.toString();
    Number = Number.replace(/ |,|บาท|฿/gi, '');
    for (var i = 0; i < Number.length; i++) {
        if (Number[i] == '.') {
            decimal = true;
        }
    }
    if (decimal == false) {
        Number = Number + '.00';
    }
    return Number
}

function ArabicNumberToText(Number) {
    var Number = CheckNumber(Number);
    var NumberArray = new Array("ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า", "สิบ");
    var DigitArray = new Array("", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน");
    var BahtText = "";
    if (isNaN(Number)) {
        return "ข้อมูลนำเข้าไม่ถูกต้อง";
    } else {
        if ((Number - 0) > 9999999.9999) {
            return "ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้";
        } else {
            Number = Number.split(".");
            if (Number[1].length > 0) {
                Number[1] = Number[1].substring(0, 2);
            }
            var NumberLen = Number[0].length - 0;
            for (var i = 0; i < NumberLen; i++) {
                var tmp = Number[0].substring(i, i + 1) - 0;
                if (tmp != 0) {
                    if ((i == (NumberLen - 1)) && (tmp == 1)) {
                        BahtText += "เอ็ด";
                    } else
                        if ((i == (NumberLen - 2)) && (tmp == 2)) {
                            BahtText += "ยี่";
                        } else
                            if ((i == (NumberLen - 2)) && (tmp == 1)) {
                                BahtText += "";
                            } else {
                                BahtText += NumberArray[tmp];
                            }
                    BahtText += DigitArray[NumberLen - i - 1];
                }
            }
            BahtText += "บาท";
            if ((Number[1] == "0") || (Number[1] == "00")) {
                BahtText += "ถ้วน";
            } else {
                var DecimalLen = Number[1].length - 0;
                for (var i = 0; i < DecimalLen; i++) {
                    var tmp = Number[1].substring(i, i + 1) - 0;
                    if (tmp != 0) {
                        if ((i == (DecimalLen - 1)) && (tmp == 1)) {
                            BahtText += "เอ็ด";
                        } else
                            if ((i == (DecimalLen - 2)) && (tmp == 2)) {
                                BahtText += "ยี่";
                            } else
                                if ((i == (DecimalLen - 2)) && (tmp == 1)) {
                                    BahtText += "";
                                } else {
                                    BahtText += NumberArray[tmp];
                                }
                        BahtText += DigitArray[DecimalLen - i - 1];
                    }
                }
                BahtText += "สตางค์";
            }
            return BahtText;
        }
    }
}

export const Tawi50PDFfile = async (type, selectedYear, data) => {
    const fontSize = 16;
    const url = `${process.env.REACT_APP_API_URL}files/${type}.pdf`;
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const urlFont = `${process.env.REACT_APP_API_URL}fonts/THSarabunNew.ttf`;
    const fontBytes = await fetch(urlFont).then((res) => res.arrayBuffer());
    pdfDoc.registerFontkit(fontkit);

    const font = await pdfDoc.embedFont(fontBytes);
    // const pages = pdfDoc.getPages();
    // const page1 = pages[0];

    const numPages = data.Employee50TawiResult.length;

    for (let i = 1; i < numPages; i++) {
        const [newPage] = await pdfDoc.copyPages(pdfDoc, [0]);
        pdfDoc.addPage(newPage);
    }

    const updatedPages = pdfDoc.getPages();

    // const Employee50TawiData = data && data.PayrunDetailResult[0];
    // const PayrunMainItem = data && data.PayrunDetailMainResult[0];
    // const DeductionItem = data && data.DeductionResult[0];
    // const AdditionData = data && data.AdditionResult[0];
    // const AdditionSummary = data && data.AdditionSummary[0];
    // const DeductionSummary = data && data.DeductionSummary[0];
    // const employeeData = data && data.employeeDetails; // All Users
    // const accumulateSSOMax = (data && data.accumulateSSOMax) ? data.accumulateSSOMax : []; // All Users
    // const accumulatePFMax = (data && data.accumulatePFMax) ? data.accumulatePFMax : []; // All Users
    // let accumulateSSO = 0;
    // let accumulatePF = 0;

    for (let i = 0; i < numPages; i++) {
        const currentPage = updatedPages[i];
        const Employee50TawiData = data && data.Employee50TawiResult[i];
        // const PayrunItem = data && data.PayrunDetailResult[0];
        // const Payrun50TawiItem = data && data.Payrun50TawiResult[0];
        // const PayrunMainItem = data && data.PayrunDetailMainResult[0];
        // const DeductionItem = data && data.DeductionResult[0];
        // const employeeData = data && data.employeeDetails;

        if (Employee50TawiData) {

            const index = Employee50TawiData.orderNumber;
            if (index !== undefined) {
                currentPage.drawText(`${index}`, { x: index > 100 ? 95 : 105, y: 605, size: fontSize, font: font });
            }
        }
        { (Employee50TawiData && Employee50TawiData.vendorName) && currentPage.drawText(`${Employee50TawiData.vendorName}`, { x: 60, y: 730, size: fontSize, font: font }); }

        currentPage.drawText(`${(
            Employee50TawiData.addressVendor &&
            Employee50TawiData.districtVendor &&
            Employee50TawiData.provinceVendor &&
            Employee50TawiData.areaCodeVendor &&
            `${Employee50TawiData.addressVendor} อำเภอ${Employee50TawiData.districtVendor} จังหวัด${Employee50TawiData.provinceVendor} ${Employee50TawiData.areaCodeVendor}`) || ""}`, { x: 60, y: 707, size: fontSize, font: font });

        //taxpayer
        currentPage.drawText(`${(Employee50TawiData.title ? Employee50TawiData.title : "") + " " + (Employee50TawiData.firstname ? Employee50TawiData.firstname : "") + " " + (Employee50TawiData.lastname ? Employee50TawiData.lastname : "")}`, { x: 60, y: 658, size: fontSize, font: font });

        if (Employee50TawiData.vendorTaxID) {
            let vendorTaxID = [
                Employee50TawiData.vendorTaxID[0],
                Employee50TawiData.vendorTaxID.slice(1, 5),
                Employee50TawiData.vendorTaxID.slice(5, 10),
                Employee50TawiData.vendorTaxID.slice(10, 12),
                Employee50TawiData.vendorTaxID[12]
            ];
            currentPage.drawText(`${vendorTaxID[0]} `, { x: 378, y: 747, size: fontSize, font: font });
            currentPage.drawText(`${vendorTaxID[1][0]}  ${vendorTaxID[1][1]} ${vendorTaxID[1][2]}  ${vendorTaxID[1][3]} `, { x: 397, y: 747, size: fontSize, font: font });
            currentPage.drawText(`${vendorTaxID[2][0]}  ${vendorTaxID[2][1]} ${vendorTaxID[2][2]}  ${vendorTaxID[2][3]}  ${vendorTaxID[2][4]} `, { x: 451, y: 747, size: fontSize, font: font });
            currentPage.drawText(`${vendorTaxID[3][0]} ${vendorTaxID[3][1]} `, { x: 518, y: 747, size: fontSize, font: font });
            currentPage.drawText(`${vendorTaxID[4]} `, { x: 548, y: 747, size: fontSize, font: font });
        }

        if (Employee50TawiData.personalId) {
            let personalId = [
                Employee50TawiData.personalId[0],
                Employee50TawiData.personalId.slice(1, 5),
                Employee50TawiData.personalId.slice(5, 10),
                Employee50TawiData.personalId.slice(10, 12),
                Employee50TawiData.personalId[12]
            ];
            currentPage.drawText(`${personalId[0]} `, { x: 378, y: 679, size: fontSize, font: font });
            currentPage.drawText(`${personalId[1][0]}  ${personalId[1][1]} ${personalId[1][2]}  ${personalId[1][3]} `, { x: 397, y: 679, size: fontSize, font: font });
            currentPage.drawText(`${personalId[2][0]}  ${personalId[2][1]} ${personalId[2][2]}  ${personalId[2][3]}  ${personalId[2][4]} `, { x: 451, y: 679, size: fontSize, font: font });
            currentPage.drawText(`${personalId[3][0]} ${personalId[3][1]} `, { x: 518, y: 679, size: fontSize, font: font });
            currentPage.drawText(`${personalId[4]} `, { x: 548, y: 679, size: fontSize, font: font });
        }

        currentPage.drawText(`${Employee50TawiData.houseNo || ""}${Employee50TawiData.vilage ? ` หมู่บ้าน${Employee50TawiData.vilage}` : ""}${Employee50TawiData.vilageNo ? ` หมู่ที่ ${Employee50TawiData.vilageNo}` : ""}${Employee50TawiData.alley ? ` ซอย${Employee50TawiData.alley}` : ""}${Employee50TawiData.road ? ` ถนน${Employee50TawiData.road}` : ""}${Employee50TawiData.subDistrict ? ` ตำบล${Employee50TawiData.subDistrict}` : ""}${Employee50TawiData.district ? ` อำเภอ${Employee50TawiData.district}` : ""}${Employee50TawiData.province ? ` จังหวัด${Employee50TawiData.province}` : ""}${Employee50TawiData.areaCode ? ` ${Employee50TawiData.areaCode}` : ""} `, {
            x: 60, y: 632, size: fontSize, font: font
        });

        currentPage.drawText(`X`, { x: 212, y: 605, size: fontSize, font: font });

        if (Employee50TawiData) {

            let accumulateSSO = Employee50TawiData.accumulateSSO || 0;
            let accumulatePF = Employee50TawiData.accumulatePF || 0;
            let AllSalary = Employee50TawiData.accumulateEarnings || 0;
            let totalTax = Employee50TawiData.accumulateTax || 0;

            //วัน เดือน ปี ที่จ่าย
            selectedYear && currentPage.drawText(`${selectedYear} `, { x: 354, y: 536, size: fontSize, font: font });

            //2. จำนวนเงินที่จ่าย
            if (AllSalary) {
                currentPage.drawText(`${AllSalary.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} `, {
                    x: AllSalary < 10 ? 450 :
                        AllSalary < 100 ? 444 :
                            AllSalary < 1000 ? 438 :
                                AllSalary < 10000 ? 430 :
                                    AllSalary < 100000 ? 424 :
                                        AllSalary < 1000000 ? 418 : 410,
                    y: 536, size: fontSize, font: font
                });
            }

            //2. ภาษีที่หัก
            currentPage.drawText(`${totalTax.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} `, { x: 495, y: 536, size: fontSize, font: font });

            //รวม
            currentPage.drawText(`${AllSalary.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} `, {
                x: AllSalary < 10 ? 450 :
                    AllSalary < 100 ? 444 :
                        AllSalary < 1000 ? 438 :
                            AllSalary < 10000 ? 430 :
                                AllSalary < 100000 ? 424 :
                                    AllSalary < 1000000 ? 418 : 410,
                y: 182, size: fontSize, font: font
            });
            currentPage.drawText(`${totalTax.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} `, {
                x: totalTax < 10 ? 523 :
                    totalTax < 100 ? 517 :
                        totalTax < 1000 ? 511 :
                            totalTax < 10000 ? 503 :
                                totalTax < 100000 ? 497 :
                                    totalTax < 1000000 ? 491 : 483,
                y: 182, size: fontSize, font: font
            });

            currentPage.drawText(`0.00`, { x: 250, y: 145, size: 12, font: font });

            let sumSSO = accumulateSSO;
            currentPage.drawText(`${sumSSO > 0 ? sumSSO.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0.00"}`, { x: 372, y: 145, size: 12, font: font });

            // let sumSF = (PayrunMainItem.SUM_PF || 0);
            let sumSF = (accumulatePF || 0);
            currentPage.drawText(`${sumSF > 0 ? sumSF.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0.00"}`, { x: 501, y: 145, size: 12, font: font })

            //Thai Baht to Text
            const thaibath = ArabicNumberToText(Number.parseFloat(totalTax).toFixed(2));
            if (thaibath && totalTax > 0) {
                currentPage.drawText(`${thaibath} `, { x: 300, y: 162, size: fontSize, font: font });
            } else if (totalTax < 1) {
                currentPage.drawText("ศูนย์บาทถ้วน", { x: 300, y: 162, size: fontSize, font: font });
            }
            currentPage.drawText(`X`, { x: 85, y: 121, size: fontSize, font: font });

            const presentDay = new Date();
            const presentDayTH = dayjs(presentDay).locale('th').format("DD");
            const presentMonthTH = dayjs(presentDay).locale('th').format("MMMM");
            const thaiYear = dayjs(presentDay).format('YYYY')
            const formattedThaiYear = parseInt(thaiYear) + 543;

            if (Employee50TawiData.authorizedSignatureOneImageFilename) {
                const imageData = await getSignatureCertificateVendor();

                const pngImage = await pdfDoc.embedPng(imageData.data);
                const pngDims = pngImage.scale(0.05);
                currentPage.drawImage(pngImage, {
                    x: 380, y: 81, width: pngDims.width, height: pngDims.height
                })
            }
            currentPage.drawText(`${presentDayTH}`, { x: 350, y: 76, size: 13, font: font });
            currentPage.drawText(`${presentMonthTH}`, { x: 372, y: 76, size: 13, font: font });
            currentPage.drawText(`${formattedThaiYear}`, { x: 430, y: 76, size: 13, font: font });
        }
    }
    const pdfBytes = await pdfDoc.save();
    const bytes = new Uint8Array(pdfBytes);
    const blob = new Blob([bytes], { type: "application/pdf" });
    const docUrl = URL.createObjectURL(blob);
    window.open(docUrl, "_blank");
}